import { Who, type Person } from "./Who";

/** One team's score: the names, the number in huge type, and big minus and plus buttons. */
export function Stepper({
  team,
  bounty,
  curse,
  value,
  onChange,
  disabled,
}: {
  team: Person[];
  /** The price on this pair this round; 0 when there is none. */
  bounty: number;
  /** "No smashes 0:43" (or "Solo: Luke alone 0:43") while this pair is cursed, else null. */
  curse?: string | null;
  value: number;
  onChange: (v: number) => void;
  disabled?: boolean;
}) {
  const who = team.map((p) => p.name).join(" and ");
  return (
    <div className={"stepper" + (curse ? " cursed" : "")}>
      <div className="stepper-names">
        {team.map((p, i) => (
          <Who key={i} who={p} />
        ))}
      </div>
      {(bounty > 0 || curse) && (
        <div className="stepper-tags">
          {curse && <span className="court-curse">{curse}</span>}
          {bounty > 0 && <span className="court-bounty">Bounty {bounty}</span>}
        </div>
      )}
      <div className="stepper-value" aria-live="polite">
        <span key={value} className="stepper-num">
          {value}
        </span>
      </div>
      <div className="stepper-buttons">
        <button
          type="button"
          className="btn quiet stepper-btn"
          aria-label={`One point less for ${who}`}
          disabled={disabled || value <= 0}
          onClick={() => onChange(Math.max(0, value - 1))}
        >
          −
        </button>
        <button
          type="button"
          className="btn stepper-btn"
          aria-label={`One point more for ${who}`}
          disabled={disabled}
          onClick={() => onChange(value + 1)}
        >
          +
        </button>
      </div>
    </div>
  );
}
